import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import {SeriesCorrectionInputData} from "../../../_models/jobs/series-correction-job";
import {BaseComponent} from "../../../shared/base.component";
import {IDMap, ModelID} from '../../../_typing/generic-types';
import {Series} from '../../../_models/series';
import {take, tap} from "rxjs/operators";
import {ListResponse} from "../../../services/api/response-types";
import {takeUntil} from "rxjs";
import {SeriesDataService} from '../../../services/series_data.service';
import {SharedPipesModule} from "../../../shared/modules/shared-pipes.module";
import {PrettyDateComponent} from "../../pretty-date/pretty-date.component";


@Component({
    selector: 'series-correction-job-input-data',
    templateUrl: './series-correction-job-input-data.component.html',
    styleUrls: ['./series-correction-job-input-data.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        SharedPipesModule,
        PrettyDateComponent
    ],
})
export class SeriesCorrectionJobInputDataComponent extends BaseComponent {
    @Input() inputData: SeriesCorrectionInputData;

    seriesDict: IDMap<Series> = {}

    constructor(private seriesDataService: SeriesDataService,
                private cdr: ChangeDetectorRef) {
        super();

    }

    ngOnInit() {
        const seriesIds: ModelID[] = this.inputData.series_to_adjust
            .reduce((acc, a) => [...acc, a.target_series_id, a.series_id], []);
        //TODO Replace with fetch from ngxs store
        const $series = this.seriesDataService.getSeriesListByIds(seriesIds).pipe(
            take(1), tap((seriesList: ListResponse<Series>) => {
                seriesList.data.forEach(s => this.seriesDict[s.id] = s);
                this.cdr.markForCheck();
            }),
            takeUntil(this.onDestroy)
        ).subscribe()
    }
}
